export const MAX_RATINGS = 5
